<template>
  <dashboard-layout>
    <template v-if="fetchDataLoading">
      <div class="big-white-card2">
          <center><div class="loader"></div></center>
        </div>
            </template>
            <template v-else>
    <div class="head-text3">Dashboard</div>
    <div class="subhead-text3">Here's a quick view of your onboarded businesses and their transactions.</div>

   

    <div class="calendar-dropdown">
  <select v-model="selectedMonth" @change="updateCalendar" class="dropdown-select">
    <option v-for="(month, index) in months" :key="index" :value="index + 1" class="dropdown-select">
      {{ month }}
    </option>
  </select>

  <select v-model="selectedYear" @change="updateCalendar" class="dropdown-select">
    <option v-for="year in years" :key="year" :value="year" class="dropdown-select">
      {{ year }}
    </option>
  </select>

  <div v-if="!showDateRange" @click="toggleDateRange" class="select-date-range">Select Date Range</div>

  <div v-if="showDateRange" style="display: flex;">
    <span class="to-text" style="color: #000; margin-right: 5px; font-size: 14px;">to</span>
    <select v-model="endMonth" class="dropdown-select">
      <option v-for="(month, index) in months" :key="index" :value="index + 1" class="dropdown-select">
        {{ month }}
      </option>
    </select>
    <select v-model="endYear" class="dropdown-select">
      <option v-for="year in years" :key="year" :value="year" class="dropdown-select">
        {{ year }}
      </option>
    </select>
    <div @click="applyDateRange" class="apply-button">Apply</div>
  </div>
</div>
<div v-if="errorDateRange" class="alert alert-danger" 
style="font-size: 12px; margin-top: 10px; margin-left: 40px; height: 40px;" role="alert">
        {{ errorDateRange }}
          </div>





    <!-- Dashboard Cards -->
    <div class="dashboard-cards">
      <!-- User Card -->
      <div class="dashboard-card user-card card1-border">
        <span class="card3-header">Sales Executives
        <img class="custom-icon" src="@/components/img/Sales_Assests/ovalIcon.svg" alt="Custom Icon">
      </span>
      <div v-if="fetchingDashboardData">
        <div class="fas fa-spinner card-value"></div>
      </div>
      <div v-else>
        <div class="card-value">{{  SalesExecutiveCount.length }}</div>
      </div>
      </div>

      <!-- Business Card -->
      <div class="dashboard-card business-card card2-border">
        <span class="card3-header">Merchants
        <img class="custom-icon" src="@/components/img/Sales_Assests/ovalIcon.svg" alt="Custom Icon">
        </span>
        <div v-if="fetchingDashboardData">
        <div class="fas fa-spinner card-value"></div>
      </div>
      <div v-else>
        <div class="card-value">{{ DashbaordData.businessOwnersCount }}</div>
        </div>
      </div>

      <!-- Transaction Volume Card -->
      <div class="dashboard-card transaction-volume-card card3-border">
        <span class="card3-header">Transaction Volume
        <img class="custom-icon" src="@/components/img/Sales_Assests/ovalIcon.svg" alt="Custom Icon">
      </span>
      <div v-if="fetchingDashboardData">
        <div class="fas fa-spinner card-value"></div>
      </div>
      <div v-else>
        <div class="card-value">{{ DashbaordData.totalVolumeCount }}</div>
        </div>
      </div>

      <!-- Transaction Value Card -->
      <div class="dashboard-card transaction-value-card card4-border">
        <span class="card3-header">Transaction Value
        <img class="custom-icon" src="@/components/img/Sales_Assests/ovalIcon.svg" alt="Custom Icon">
      </span>
      <div v-if="fetchingDashboardData">
        <div class="fas fa-spinner card-value"></div>
      </div>
      <div v-else>
        <div class="card-value">₦{{ formatAmount(DashbaordData.totalValueCount) }}</div>
        </div>
      </div>
    </div>

    
    <div class="big-white-card">
      <div v-if="showChart === false">
      <div class="center-content">
        <img class="custom-icon-size" src="@/components/img/Sales_Assests/centercardicon.svg" alt="Custom Icon">
        <p class="write-up">
          No data to display yet
        </p>
        <div class="subhead-text2">You are yet to onboard a business under your profile. After</div>
        <div class="subhead-text2">onboarding a business, their transaction analytics will be</div>
        <div class="subhead-text2">displayed here.</div>
      </div>
    </div>

    <div v-else>

      <p class="write-up">
          Transactions
        </p>
      <!-- Tab Buttons -->
      <div class="tab-buttons">
        <button
          :class="{ activeTab: selectedTab === 'value' }"
          @click="selectTab('value')"
        >
          Value
        </button>
        <!-- <button
          :class="{ activeTab: selectedTab === 'volume' }"
          @click="selectTab('volume')"
        >
          Volume
        </button> -->
      </div>

    
      <div v-if="selectedTab === 'value'">

        <div class="chart-container">
    <canvas id="myChart"></canvas>
  </div>

      </div>

      <div v-else-if="selectedTab === 'volume'">
        <canvas id="myChart" width= 100% height= 100%></canvas>
      </div>
    </div>
  </div>
</template>

  </dashboard-layout>
</template>
  
  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  import Chart from 'chart.js/auto';
  import axios from 'axios'; 

  
  export default {
    name: 'sales-dashboard',

  
    components: {
      DashboardLayout,
    },
  
    data() {
    return {
      myChart: null,
      errorDateRange: false,
      fetchingDashboardData: false,
      selectedTab: 'value',
      selectedMonth: new Date().getMonth() + 1, 
      selectedYear: new Date().getFullYear(),
      endMonth: new Date().getMonth() + 1, 
      endYear: new Date().getFullYear(),
      months: [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
      ],
      years: [],
      showDateRange: false,
      showChart: true,
      userID: '',
      DashbaordData: null,
      fetchDataLoading: true,
      onboardedData: null,
      SalesExecutiveCount: '',
    };
  },
  async mounted() {

    this.userID = sessionStorage.getItem('userId');

    try{
      // await this.fetchAllOnboardedMerchants();
      await this.getAllSaleExecutiveCount();
      await this.fetchReports();
      this.fetchDataLoading = false;
    }catch(error)
    {
      console.log(error);
    }

    this.$nextTick(() => {
    this.initializeChart();
  });
   
    const currentYear = new Date().getFullYear();
    for (let year = 2000; year <= 2030; year++) {
      this.years.push(year);
    }
    console.log(currentYear);
  },

  computed: {
    filteredSalesExecutiveCount() {
      return this.filterSalesExecutivesByDateRange();
    },
  },


  methods: {

    filterSalesExecutivesByDateRange() {
  if (!this.endYear && !this.endMonth) {
    return this.SalesExecutiveCount;
  } else {
    const startDate = new Date(this.selectedYear, this.selectedMonth - 1, 1);
    const endDate = new Date(this.endYear, this.endMonth, 0, 23, 59, 59);

    console.log(`Start Date: ${startDate.toISOString()}`);
    console.log(`End Date: ${endDate.toISOString()}`);

    return this.SalesExecutiveCount.filter(executive => {
      const createdAt = new Date(executive.CreatedAt);
      console.log(`CreatedAt: ${createdAt.toISOString()}`);
      return createdAt <= startDate && createdAt >= endDate;
    });
  }
},


    formatAmount(amount) {
  const parsedAmount = parseFloat(amount);

 
  if (isNaN(parsedAmount)) {
    console.error('Invalid amount:', amount);
    return ''; 
  }


  const roundedAmount = parsedAmount.toFixed(2);

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true 
  });

  return formatter.format(roundedAmount);
},

    async getAllSaleExecutiveCount(){

      try{
        const response = await axios.get(this.$config.GETUSERS_ENDPOINT);
        this.SalesExecutiveCount = response.data.filter(user => user.Role === 'Sales Executive');
      }catch (error) {
      console.error('Error fetching Sales Executive count', error);
    }
      
    },
    

    async fetchAllOnboardedMerchants() {
    try {
      const response = await axios.get(`${this.$config.GETMERCHANT_ENDPOINT}/${this.userID}`);
     
      this.onboardedData = response.data.data;
      if(this.onboardedData.length == 0){
        this.showChart = false;
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  },

    updateCalendar() {

      console.log(`Selected Month: ${this.selectedMonth}, Selected Year: ${this.selectedYear}`);
    },
    toggleDateRange() {
      this.showDateRange = !this.showDateRange;
    },

   async applyDateRange() {
  const startDate = new Date(this.selectedYear, this.selectedMonth - 1); 
  const endDate = new Date(this.endYear, this.endMonth - 1); 


  if (startDate > endDate) {
   
    this.errorDateRange = 'Start date cannot be greater than End date';
    setTimeout(() => {
        this.errorDateRange = false;
      }, 3000);
    console.error('Start date cannot be greater than End date');
    return; 
  }
  else{
    this.fetchingDashboardData = true; 

    try {
      const response = await axios.get(`${this.$config.SUPERADMINDASHBOARDATA_ENDPOINT}?StartDate.Month=${this.selectedMonth}&StartDate.Year=${this.selectedYear}&EndDate.Month=${this.endMonth}&EndDate.Year=${this.endYear}`);
     
      if(response.status == 200){
        this.SalesExecutiveCount = this.filterSalesExecutivesByDateRange();
        this.DashbaordData = response.data.data;
        this.fetchingDashboardData = false;
        this.initializeChart();
      }
      else{
        this.errorDateRange = 'An Error occured while fetching Dashbaord Data';
        this.fetchingDashboardData = false;
        setTimeout(() => {
        this.errorDateRange = false;
      }, 3000);
      }
    } catch (error) {
      this.errorDateRange = 'An Error occured while fetching Dashbaord Data';
      setTimeout(() => {
        this.errorDateRange = false;
      }, 3000);
      console.error('Error fetching Dashbaord Data', error);
    }

  }
},

    async fetchReports() {
    try {
      const currentDate = new Date();
    
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add 1 because getMonth() returns zero-based index
    const currentYear = currentDate.getFullYear();

      const response = await axios.get(`${this.$config.SUPERADMINDASHBOARDATA_ENDPOINT}/?StartDate.Month=01&StartDate.Year=2023&EndDate.Month=${currentMonth}&EndDate.Year=${currentYear}`);
     
      this.DashbaordData = response.data.data;
      if(this.DashbaordData.length == 0){
        this.showChart = false;
      }
      console.log('Dashbaord Data',  this.DashbaordData);
    } catch (error) {
      console.error('Error fetching Dashbaord Data', error);
    }
  },

  initializeChart() {
  const ctx = document.getElementById('myChart');
  if (ctx && this.DashbaordData && this.DashbaordData.graphPoints) {
    const graphPoints = this.DashbaordData.graphPoints;

    // Function to format day with correct ordinal suffix
    const getOrdinalSuffix = (day) => {
      const suffixes = ['th', 'st', 'nd', 'rd'];
      const v = day % 100;
      return day + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    };

    // Extracting day and amount data from graphPoints
    const labels = graphPoints.map(point => {
      const date = new Date(point.date);
      return getOrdinalSuffix(date.getDate()); // Use the function to format
    });

    const data = {
      labels: labels,
      datasets: [{
        label: 'Transaction Value',
        data: graphPoints.map(point => point.totalAmount),
        fill: true,
        backgroundColor: '#EBFCD5', 
        borderColor: '#44AC21',
        borderWidth: 0.7,
        tension: 0.4,
        intersect: true,
      }],
    };

    let maxAmount = Math.max(...graphPoints.map(point => point.totalAmount));
     maxAmount = maxAmount == 0 ? 6 : maxAmount;

     console.log('Gotten max amount is:', maxAmount);

    const options = {
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        y: {
          ticks: {
            min: 0,
            stepSize: Math.ceil(maxAmount / 6),
            callback: function (value) {
              if (value >= 1000) {
                return '₦' + (value / 1000).toFixed(0) + 'K';
              }
              return '₦' + value;
            }  
          },
          grid: {
            display: false
          }
        }
      },
      responsive: true,
      plugins: {
        legend: {
          position: 'center',
        },
        title: {
          display: false,
          text: 'Transactions',
        },
      },
    };

    // Destroy existing chart instance if any
    if (this.myChart) {
      this.myChart.destroy();
    }

    // Create new chart instance
    this.myChart = new Chart(ctx, {
      type: 'line',
      data: data,
      options: options,
    });

    console.log(this.myChart);
  }
},





selectTab(tab) {
    // Destroy the existing chart instance before switching tabs
    if (this.myChart) {
      this.myChart.destroy();
    }

    this.selectedTab = tab;

    // Initialize the chart for the selected tab
    if (this.selectedTab === 'value' || this.selectedTab === 'volume') {

      setTimeout(() => {
        this.initializeChart();
      }, 100);
     
    }
    // Add logic for other tabs if needed
  },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    

    hideDropdown() {
      this.showDropdown = false;
    },
  },
  
  };
  </script>
  
  <style>

.chart-container {
  position: relative;
  height: 100%;
  width: 100%;
}

#myChart {
  width: 100% !important;
  height: 100% !important;
}

 

  .apply-button{
    height: 25px;
    width: auto;
    padding: 5px;
    background-color: #6F48FF;
    color: #fff;
    font-size: 11px;
    border-radius: 3px;
    margin-left: 5px;
    cursor: pointer;
  }

  .select-date-range{
    height: 25px;
    width: auto;
    padding: 5px;
    background-color: #D1D5DB;
    color: #000;
    font-size: 11px;
    border-radius: 3px;
    cursor: pointer;
  }

  .canvasTop {
    border-top: 1px;
  }

.tab-buttons {
  display: flex;
  margin-bottom: 40px;
}

.tab-buttons button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-right: 10px;
  padding: 10px;
  color: #b0a8a8;
}

.tab-buttons button.activeTab {
  border-bottom: 2px solid #6F48FF; /* Active tab indicator color */
  color: #000; /* Active tab text color */
}

.calendar-dropdown {
  border-radius: 5px;
  display: flex;
  margin-left: 40px;
  margin-top: 10px;
  font-size: 12px;
  height: 25px;
  
}

.dropdown-select {
  margin-right: 5px;
  border: 1px solid #000;
  text-align: center;
  border-radius: 3px;
  font-size: 12px;
  transition: border-color 0.3s ease-in-out;
}

.dropdown-select:hover {
  border-color: #4CAF50; /* Green border on hover */
}

.dropdown-select::-webkit-scrollbar {
  width: 2px; /* Set the width of the scrollbar */
}

.dropdown-select::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Optional: Add rounded corners to the thumb */
}


  .custom-icon-size{
    height: 70px;
    width: auto;
  }

.big-white-card {
    background-color: #FFF; 
    margin: 20px 40px; 
    padding: 20px; 
    min-height: 500px;
    height: auto;
    width: auto;
    overflow: hidden;
  }

  .big-white-card2 {
    background-color: transparent; /* White background color */
    margin: 20px 40px; /* Margin as needed */
    padding: 20px; /* Padding as needed */
    height: 500px;
  }

  .center-content {
    text-align: center;
    margin-top: 160px;
    
  }


  .write-up {
    font-size: 16px;
    margin-top: 10px;
    color: #000;
    font-weight: bold;
  }

  .head-text {
  margin-left: 40px;
  font-size: 22px;
  color: #000;
  font-weight: bold;
  }

  .oval-icon{
    margin-left: 70px;
  }
  .oval-icon2{
    margin-left: 58px;
  }

  .oval-icon3a{
    display: flex;
    
  }

  .subhead-text{
  margin-left: 40px;
  font-size: 14px;
}

.subhead-text2{
  font-size: 14px;
}

.dashboard-cards {
  display: flex;
  justify-content: space-between;
  margin: 20px 40px;
}

.dashboard-card {
  flex: 1;
  /* border: 1px solid #624915; */
  /* border-radius: 5px; */
  padding-top: 10px;
  background-color: #FFF9ED;
  height: 90px;
  width: 100px;

}

.card1-border{
  border-left: 1px solid #624915 ;
  border-top: 1px solid #624915 ;
  border-bottom: 1px solid #624915 ;
  border-radius: 3px;
}

.card2-border{
  border-left: 1px solid #624915 ;
  border-top: 1px solid #624915 ;
  border-bottom: 1px solid #624915 ;
}

.card3-border{
  border-left: 1px solid #624915 ;
  border-top: 1px solid #624915 ;
  border-bottom: 1px solid #624915 ;
  border-right: 1px solid #624915 ;
}

.card4-border{
  border-right: 1px solid #624915 ;
  border-top: 1px solid #624915 ;
  border-bottom: 1px solid #624915 ;
  border-radius: 3px;

}

.card3-header {
  font-size: 13px;
  padding-left: 10px;
  padding-bottom: 10px;
  color: #000;
  display: flex;
  justify-content: space-between;
}

.card-value {
  font-size: 20px;
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 0px;
  font-weight: bolder;
  color: #000;
}
  
  </style>
  